import { gql, useQuery } from "@apollo/client";
import { Grid } from "@mui/material";
import { ErrorComponent } from "@src/components";
import { DetailPageHeader } from "@src/components/headers/DetailPageHeader";
import LoadingComponent from "@src/components/LoadingComponent";
import LogsTable from "@src/domain/users/edit/LogsTable";
import { type GQLUserAdminQuery, type GQLUserAdminQueryVariables } from "@src/graphql.generated";
import { type FC, type PropsWithChildren } from "react";

import DevicesTable from "./DevicesTable";
import EditForm from "./Form";
// eslint-disable-next-line @comet/no-private-sibling-import
import { userFragment } from "./fragments.gql";
import LicencesTable from "./LicencesTable";
import TrapAlarmTable from "./TrapAlarmTable";

const userQuery = gql`
    query UserAdmin($id: ID!) {
        userAdmin(id: $id) {
            ...UserFragment
        }
    }
    ${userFragment}
`;

interface Props {
    id: string;
}

export const EditUser: FC<PropsWithChildren<Props>> = ({ id }) => {
    const { data, error, loading } = useQuery<GQLUserAdminQuery, GQLUserAdminQueryVariables>(userQuery, { variables: { id } });

    if (error) {
        return <ErrorComponent />;
    }

    if (loading || !data) {
        return <LoadingComponent />;
    }

    return (
        <>
            <DetailPageHeader />
            <Grid container spacing={4}>
                <Grid size={6}>
                    <Grid container spacing={4}>
                        <Grid size={12}>
                            <EditForm userAdmin={data.userAdmin} />
                        </Grid>
                        <Grid size={12}>
                            <TrapAlarmTable userAdmin={data.userAdmin} />
                        </Grid>
                        <Grid size={12}>
                            <LogsTable userAdmin={data.userAdmin} />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={6}>
                    <Grid container spacing={4}>
                        <Grid size={12}>
                            <DevicesTable userAdmin={data.userAdmin} />
                        </Grid>
                        <Grid size={12}>
                            <LicencesTable userAdmin={data.userAdmin} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};
